"use client";
import Select from "@/components/primitives/select";
import { generateYearOptions } from "@/utils";
import { useParamUpdater } from "@/utils/hooks/navigation";
import { getSeasonOptions } from "@/utils/sports";
import { CurrentSeason, Season, Sport, formatServerSeason, getDefaultYear, toSeasonType } from "common";
import { useRouter } from "next-nprogress-bar";
import React from "react";

export interface StatsFilterParams {
  sport: Sport;
  year: string;
  season?: Season[];
}
export default function StatsFilter({
  timeframe,
  params,
}: {
  timeframe: any;
  params: StatsFilterParams;
}) {
  const { createParamString } = useParamUpdater();
  const router = useRouter();
  // console.log("current season", currentSeason);

  const isCurrentYear: boolean = params.year === `${timeframe.season}`;
  const season: string = (params.season?.[0] || formatServerSeason(timeframe.season_type, true)) as string;
  // const seasonType = toSeasonType(season as Season);
  const seasonOptions: Option[] = getSeasonOptions(isCurrentYear ? timeframe.season_type : 3);
  console.log("timeframe", timeframe);
  return (
    <>
      <Select
        label="Select Year"
        value={`${timeframe.season}`}
        options={generateYearOptions(params.sport, getDefaultYear(params.sport), 4)}
        defaultValue={`${timeframe.season}`}
        onValueChange={(v) =>
          router.replace(createParamString(v, 2) || timeframe.season, {
            scroll: false,
          })
        }
      />
      <Select
        label="Select Season"
        value={season}
        options={seasonOptions}
        onValueChange={(v) =>
          router.replace(createParamString(v, 3) || season, {
            scroll: false,
          })
        }
      />
    </>
  );
}
